module.exports = __webpack_public_path__ + "img/tip-image-3.6d0490a8.png";